module.exports = __webpack_public_path__ + "img/mau5-2-nhan-74x22mm.459a694c.jpg";